import styled from 'styled-components';
import RatingIcon from '../../../../icons/star';

export const TopHotelColWrap = styled.div`
  @media (max-width: 768px) {
    & {
      width: 100%;
      padding: 0 ${props => props.theme.spacing.custom(0)};
    }
  }
  width: 33.333333%;
  padding: 0 ${props => props.theme.spacing.custom(10)};
`;

export const TopHotelCol = styled.div`
  width: 100%;
  margin-bottom: 20px;
  border: 1px solid #e6e6e6;
  height: ${props => (props.isHotel ? '440px' : '340px')};
  position: relative;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.24);
  background: #fff;
`;

export const TopHotelAttr = styled(TopHotelCol)`
  height: 340px;
`;

export const HotelImgBg = styled.div`
  background: #999 url(http://www.goibibo.com/styleguide/images/Lowest-Price-grey.png) no-repeat 50%
    50%;
  width: 100%;
  height: 228px;
  position: relative;
`;

export const HotelImg = styled.img`
  width: 100%;
  height: 228px;
  cursor: pointer;
`;

export const HotelNameRating = styled.div`
  padding: ${props => props.theme.spacing.custom(10)};
`;

export const HotelHead = styled.div`
  font-size: ${props => props.theme.font.custom(18)};
  cursor: pointer;
  a {
    text-decoration: none;
    color: #3872bd;
  }
`;

export const HotelSubHead = styled.div``;

export const HotelRating = styled.div``;

export const HotelReview = styled.div`
  background-color: #f4f4f4;
  padding: ${props => props.theme.spacing.custom(10)};
  a {
    text-decoration: none;
  }
`;

export const HotelPrice = styled.div`
  padding: ${props => props.theme.spacing.custom(10)};
`;

export const ReviewDate = styled.span`
  font-size: ${props => props.theme.font.custom(11)};
`;

export const ReviewTxt = styled.div`
  font-size: ${props => props.theme.font.custom(13)};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 100%;
  overflow: hidden;
  line-height: 1.3;
`;

export const Star = styled(RatingIcon)`
  path ~ path {
    fill: ${props => (props.isTrue ? '#FDCC0D' : '#efefef')};
  }
`;

export const FlightFareChart = styled.div`
  border-radius: 6px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e6e6e6;
  padding: ${props => props.theme.spacing.custom(10)};
  margin: ${props => props.theme.spacing.custom(10)} 0;
  background-color: #ffffff;
  a {
    text-decoration: none;
  }
`;

export const RouteHd = styled.div`
  font-size: 1.8rem;
`;

export const RouteBook = styled.div`
  width: 100px;
`;

export const Price = styled.div`
  font-size: ${props => props.theme.font.custom(20)};
  font-family: ${props => props.theme.font.fontFamily};
`;
